var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelinesSplit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0578 12.8693C13.302 13.0932 13.698 13.0932 13.9422 12.8693C14.1864 12.6453 14.1864 12.2822 13.9422 12.0582L13.0578 12.8693ZM0.999435 0.427016C0.654043 0.427017 0.374048 0.683777 0.374048 1.00051L0.374048 6.16192C0.374049 6.47865 0.654044 6.73541 0.999435 6.73541C1.34483 6.73541 1.62482 6.47865 1.62482 6.16192V1.574H6.62792C6.97331 1.574 7.2533 1.31724 7.2533 1.00051C7.2533 0.683778 6.97331 0.427017 6.62792 0.427017L0.999435 0.427016ZM13.9422 12.0582L1.44165 0.594988L0.55722 1.40603L13.0578 12.8693L13.9422 12.0582Z",
    fill: "#2968C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6922 9.42981C17.448 9.65377 17.052 9.65377 16.8078 9.42981C16.5636 9.20585 16.5636 8.84273 16.8078 8.61877L17.6922 9.42981ZM26.0004 0.426535C26.3458 0.426535 26.6258 0.683296 26.6258 1.00003L26.6258 6.16144C26.6258 6.47817 26.3458 6.73493 26.0004 6.73493C25.655 6.73493 25.375 6.47817 25.375 6.16144L25.375 1.57352L20.3719 1.57352C20.0265 1.57352 19.7465 1.31676 19.7465 1.00003C19.7465 0.683296 20.0265 0.426535 20.3719 0.426535L26.0004 0.426535ZM16.8078 8.61877L25.5582 0.594507L26.4426 1.40554L17.6922 9.42981L16.8078 8.61877Z",
    fill: "#2968C9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1 12.6415C14.1 12.3101 13.8314 12.0415 13.5 12.0415C13.1686 12.0415 12.9 12.3101 12.9 12.6415H14.1ZM12.9 24.4988C12.9 24.8301 13.1686 25.0988 13.5 25.0988C13.8314 25.0988 14.1 24.8301 14.1 24.4988H12.9ZM12.9 12.6415V24.4988H14.1V12.6415H12.9Z",
    fill: "#2968C9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinesSplit);
export default __webpack_public_path__ + "static/media/pipelines-split.63396d279cb4f094c91159904fd7e8ca.svg";
export { ForwardRef as ReactComponent };